import Icon from './Icon';

// Who can grant access, in the same words the server's toasts use
// (server/lib/supplierVisibility.js OWNER_CONTACT).
export const NO_ACCESS_HELP = 'אם צריך גישה, אפשר לפנות לבעלים או לצוות Peak.';

// Full-page answer to a direct link / stale id for an HQ-only supplier or its
// document. The title is the server's message; it never carries a name or amount.
export default function NoAccessNotice({ message }) {
  return (
    <div className="no-access" role="alert">
      <div className="no-access-mark"><Icon name="lock" size={28} /></div>
      <h1 className="no-access-title">{message}</h1>
      <p className="no-access-help">{NO_ACCESS_HELP}</p>
    </div>
  );
}
